import { ReactNode, useEffect } from "react";
import { useTokenContext } from "src/contexts/tokenContext";
import { setDmApiToken } from "src/dm/utils/axios";

/**
 * Bridges RP's MSAL access token (held in TokenContext at App.tsx level)
 * into DM's module-level axios client. DM hooks call `apiClient.get(...)`
 * without any awareness of where the bearer comes from; this component
 * keeps the module-level token in sync with the React context.
 *
 * Wrap DM's AppLayout with this in the /dm route's element so every DM
 * page gets the current token attached to its API calls.
 */
export const DmTokenBridge = ({ children }: { children: ReactNode }) => {
  const { accessToken } = useTokenContext();
  useEffect(() => {
    setDmApiToken(accessToken);
  }, [accessToken]);
  return <>{children}</>;
};
